export const NEWS_SOURCES = {
  LOCAL: 'local',
  NATIONAL: 'national',
};

export const NEWS_SOURCE_OPTIONS = [
  { id: NEWS_SOURCES.LOCAL, label: 'Local News' },
  { id: NEWS_SOURCES.NATIONAL, label: 'National News' },
];

export const NEWS_CATEGORY_OPTIONS = [
  { id: 'centenary', label: 'Centenary' },
  { id: 'planning', label: 'Planning' },
  { id: 'projects', label: 'Projects' },
  { id: 'nature', label: 'Nature' },
  { id: 'general', label: 'General' },
  { id: 'campaigns', label: 'Campaigns' },
];

export const DEFAULT_EXTERNAL_URL = 'https://www.cpre.org.uk/news/';

const resolveApiBase = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '');
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');
  }
  return '';
};

export const API_BASE = resolveApiBase();
export const API_URL = API_BASE ? `${API_BASE}/api` : '/api';

export { resolveNewsImageUrl as resolveAdminImagePreviewUrl } from '../../utils/newsArticle';

export const EMPTY_ARTICLE_FORM = {
  title: '',
  content: '',
  excerpt: '',
  author: 'CPRE Rutland & Lincolnshire',
  category: 'general',
  source: NEWS_SOURCES.LOCAL,
  external_url: '',
  image_url: '',
  published: true,
  created_at: '',
};

export const articleToFormData = (article) => {
  const createdAt = article?.created_at
    ? new Date(article.created_at).toISOString().slice(0, 10)
    : '';

  return {
    title: article?.title || '',
    content: article?.content || '',
    excerpt: article?.excerpt || '',
    author: article?.author || 'CPRE Rutland & Lincolnshire',
    category: article?.category || 'general',
    source: article?.source === NEWS_SOURCES.NATIONAL ? NEWS_SOURCES.NATIONAL : NEWS_SOURCES.LOCAL,
    external_url: article?.external_url || '',
    image_url: article?.image_url || '',
    published: article?.published !== false,
    created_at: createdAt,
  };
};

export const formDataToPayload = (formData) => {
  const payload = {
    title: formData.title.trim(),
    content: formData.content.trim(),
    excerpt: formData.excerpt.trim(),
    author: formData.author.trim() || 'CPRE Rutland & Lincolnshire',
    category: formData.category,
    source: formData.source,
    image_url: formData.image_url.trim(),
    published: formData.published,
  };

  if (formData.source === NEWS_SOURCES.NATIONAL) {
    payload.external_url = formData.external_url.trim();
  } else {
    payload.external_url = '';
  }

  if (formData.created_at) {
    payload.created_at = new Date(`${formData.created_at}T00:00:00.000Z`).toISOString();
  }

  return payload;
};

export const validateArticleForm = (formData) => {
  const errors = [];

  if (!formData.title.trim()) errors.push('Title is required.');
  if (!formData.excerpt.trim()) errors.push('Excerpt is required.');
  if (!formData.content.trim()) errors.push('Content is required.');
  if (!formData.category) errors.push('Category is required.');
  if (!formData.source) errors.push('News type is required.');

  if (formData.source === NEWS_SOURCES.NATIONAL) {
    const url = formData.external_url.trim();
    if (!url) {
      errors.push('External link is required for National News.');
    } else if (
      !url.startsWith('http://') &&
      !url.startsWith('https://') &&
      !url.startsWith('mailto:')
    ) {
      errors.push('External link must start with http://, https://, or mailto:.');
    }
  }

  return errors;
};

export const formatArticleDate = (dateStr) => {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const truncateExcerpt = (text, maxLength = 60) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trim()}…`;
};

export const getCategoryLabel = (categoryId) =>
  NEWS_CATEGORY_OPTIONS.find((option) => option.id === categoryId)?.label || categoryId;

export const getSourceLabel = (sourceId) =>
  NEWS_SOURCE_OPTIONS.find((option) => option.id === sourceId)?.label ||
  (sourceId === NEWS_SOURCES.NATIONAL ? 'National News' : 'Local News');
